<template>
  <div
    v-loading.fullscreen="loading"
    class="app-main-content"
    element-loading-text="Loading..."
    element-loading-spinner="el-icon-loading"
  >
    <div class="tabs-container">
      <el-tabs v-if="showView" v-model="activeTabName" type="card" style="width:100%;height: 100%">
        <el-tab-pane v-if="singleReleaseVerifyViewHbl" :lazy="true" :label="$t('CargoMsg.Cargo_BLReleaseReview')" name="singleReleaseVerifyViewHbl" style="width:100%;height: 100%">
          <single-release-verify-view-hbl
            tab-name="singleReleaseVerifyViewHbl"
            :tab-title="$t('CargoMsg.Cargo_BLReleaseReview')"
          />
        </el-tab-pane>
        <el-tab-pane v-if="hblSingleReleaseView" :lazy="true" :label="$t('CargoMsg.Cargo_BLReleaseManagement')" name="hblSingleReleaseView" style="width:100%;height: 100%">
          <hbl-single-release-view
            tab-name="hblSingleReleaseView"
            :tab-title="$t('CargoMsg.Cargo_BLReleaseManagement')"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>

import checkPermission from '@/utils/permission'
import SingleReleaseVerifyViewHbl from '@/views/cargo/v0/Clearing/components/releaseControl/singleReleaseVerifyViewHbl'
import hblSingleReleaseView from '@/views/cargo/v0/Clearing/components/releaseControl/hblSingleReleaseView'

export default {
  name: 'FmHBLSingleRelease',
  components: { SingleReleaseVerifyViewHbl, hblSingleReleaseView },
  data() {
    return {
      loading: true,
      activeTabName: 'singleReleaseVerifyViewHbl',
      singleReleaseVerifyViewHbl: false,
      hblSingleReleaseView: false,
      showView: true
    }
  },
  async created() {
    this.loading = false
    this.singleReleaseVerifyViewHbl = checkPermission(['tab_SingleReleaseHBL_tabSingleReleaseVerify'])
    this.hblSingleReleaseView = checkPermission(['tab_SingleReleaseHBL_tabSingleRelease'])
    if (this.singleReleaseVerifyViewHbl) {
      this.activeTabName = 'singleReleaseVerifyViewHbl'
    } else if (this.hblSingleReleaseView) {
      this.activeTabName = 'hblSingleReleaseView'
    }
    this.showView = !(!this.singleReleaseVerifyViewHbl && !this.hblSingleReleaseView)
  }
}
</script>
